module.exports = __webpack_public_path__ + "6625daffe275ad0761b3fe315a7631ef.png";